var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup7156(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7156",
    "data-name": "Group 7156",
    transform: "translate(-912 -276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit_score_black_24dp_1_",
    "data-name": "credit_score_black_24dp (1)",
    transform: "translate(912 276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7070",
    "data-name": "Group 7070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46979",
    "data-name": "Path 46979",
    d: "M0,0H160V160H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7071",
    "data-name": "Group 7071",
    transform: "translate(13.333 26.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46980",
    "data-name": "Path 46980",
    d: "M122,4H15.333A13.231,13.231,0,0,0,2.067,17.333L2,97.333a13.287,13.287,0,0,0,13.333,13.333H42A6.686,6.686,0,0,0,48.667,104h0A6.686,6.686,0,0,0,42,97.333H15.333v-40h120v-40A13.373,13.373,0,0,0,122,4Zm0,26.667H15.333V17.333H122ZM88.2,105.133,74.067,91a6.639,6.639,0,0,0-9.4,0h0a6.639,6.639,0,0,0,0,9.4l18.867,18.867a6.639,6.639,0,0,0,9.4,0l37.733-37.733a6.639,6.639,0,0,0,0-9.4h0a6.639,6.639,0,0,0-9.4,0Z",
    transform: "translate(-2 -4)",
    fill: "#2e8b57"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7156);
export default __webpack_public_path__ + "static/media/Group 7156.aa7c1db31f058a2e444edf65549027e8.svg";
export { ForwardRef as ReactComponent };